import React from 'react'

const Redirect: React.FC = () => {
  return <div>...</div>
}

export default Redirect
